export default __webpack_public_path__ + "static/media/plus.f3cd7b9c.svg";